import { v1 as uuidv1 } from 'uuid';
import { map, filter, every, get, find } from 'lodash';
import {
  ANSWER_DEFAULT,
  ANSWER_NONE_OF_THE_ABOVE,
} from 'containers/QuestionnairePage/constants';
import { SCREENING_ALLOWED_VALUES } from './constants';

const getEmptyAnswer = () => ({
  body: '',
  refId: uuidv1(),
  type: ANSWER_DEFAULT,
  media: undefined,
  screenerType: SCREENING_ALLOWED_VALUES.ALLOWED,
});

const getEmptyNoneOfTheAboveAnswer = () => ({
  body: 'None of the above',
  refId: uuidv1(),
  type: ANSWER_NONE_OF_THE_ABOVE,
  media: undefined,
  screenerType: SCREENING_ALLOWED_VALUES.ALLOWED,
});

const defaultAnswersSelector = (answers) =>
  answers.filter((answer) => answer.type === ANSWER_DEFAULT);

const getActiveValues = (values, isScreening = true) =>
  filter(
    values,
    ({ screenerType, body, media }) =>
      (screenerType === SCREENING_ALLOWED_VALUES.ALLOWED || !isScreening) &&
      (body || get(media, 'url', false) !== false),
  );

const getInitializedQuota = (values, completes, isScreening = true) => {
  const activeValues = getActiveValues(values, isScreening);
  let updatedValues = null;

  const quotaIsNotInitialized = every(
    activeValues,
    (value) => get(value, 'quotaCompletes', false) === false,
  );

  if (quotaIsNotInitialized) {
    const count = activeValues.length;
    const itemQuotaCompletes = Math.floor(completes / count);
    const lastItemQuotaCompletes = completes - itemQuotaCompletes * (count - 1);
    const lastItemId = activeValues[count - 1].refId;

    updatedValues = map(values, (value) => {
      const isLastItem = value.refId === lastItemId;
      const isActiveItem = find(
        activeValues,
        ({ refId }) => value.refId === refId,
      );
      const quotaCompletes = isLastItem
        ? lastItemQuotaCompletes
        : itemQuotaCompletes;

      if (isActiveItem) {
        return { ...value, quotaCompletes };
      }

      return value;
    });

    return updatedValues;
  }
  return values;
};

export {
  getEmptyAnswer,
  getEmptyNoneOfTheAboveAnswer,
  defaultAnswersSelector,
  getActiveValues,
  getInitializedQuota,
};
